<script lang="ts">
  import type { WorkOrderAppointmentHistoryTag } from "./_logic/types"
  import type { StatusDefinition } from "@kontextwerk/web-sdk/core/display/status"
  import StatusTag from "@kontextwerk/web-sdk/ui/display/StatusTag.svelte"
  import { RICH_TOOLTIP_CLASS } from "../../../../../_shared/_logic/rich-tooltips"

  type Props = {
    status: StatusDefinition<string> | null
    subLabel?: string | null
    tooltipContent?: string | null
    historyItems?: WorkOrderAppointmentHistoryTag[]
    historyLayout?: "row" | "stack"
    fallbackLabel?: string | null
    disabled?: boolean
  }

  const {
    status,
    subLabel = null,
    tooltipContent = null,
    historyItems = [],
    historyLayout = "row",
    fallbackLabel = "—",
    disabled = false,
  }: Props = $props()
</script>

{#if status}
  <span class="appointment-cell" class:disabled>
    <StatusTag
      size="sm"
      {status}
      subLabel={subLabel ?? undefined}
      tooltipContent={tooltipContent ?? ""}
      tooltipHtml={true}
      tooltipClassName={RICH_TOOLTIP_CLASS}
      disableTitle={true}
    />
    {#if historyItems.length}
      <span
        class={`appointment-cell__history${historyLayout === "stack" ? " appointment-cell__history--stack" : ""}`}
      >
        {#each historyItems as item}
          <StatusTag
            size="sm"
            status={item.status}
            subLabel={item.subLabel ?? undefined}
            tooltipContent={item.tooltip ?? ""}
            tooltipHtml={true}
            tooltipClassName={RICH_TOOLTIP_CLASS}
            disableTitle={true}
          />
        {/each}
      </span>
    {/if}
  </span>
{:else}
  <span class="appointment-cell__fallback" class:disabled>{fallbackLabel || "—"}</span>
{/if}

<style lang="less">
  .appointment-cell {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.14rem;
    max-width: 100%;
  }

  .appointment-cell.disabled {
    opacity: 0.58;
  }

  .appointment-cell__history {
    display: inline-flex;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 0.14rem;
    max-width: 100%;
  }

  .appointment-cell__history--stack {
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .appointment-cell__fallback {
    color: var(--text-invers-100);
    font-weight: 600;
  }

  .appointment-cell__fallback.disabled {
    font-weight: 500;
    opacity: 0.62;
  }
</style>
